import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET } from "@angular/router";
import "rxjs/add/operator/filter";
import { APP_ROUTER_PROVIDERS } from "./../../app.routes";
declare var require: any;

interface IBreadcrumb {
    label: string;
    params: Params;
    url: string;
}

@Component({
    selector: 'MentisSoft-Breadcrumb',
    template: require('./Breadcrumb.template.html'),
    styles: [require('./Breadcrumb.css')]
})

export class BreadcrumbComponent implements OnInit {
    public breadcrumbs: IBreadcrumb[];
    currentPage: string = " -";
    constructor(private activatedRoute: ActivatedRoute, private router: Router) {
        if (router.parseUrl(router.url).toString().includes("?")) {
            let teststr: string = router.parseUrl(router.url).toString().split('?')[0];
            this.currentPage = teststr.split('/')[1];
        } else {
            this.currentPage = router.parseUrl(router.url).toString().split('/')[1];
        }
        this.breadcrumbs = [];
    }
    Hospital: string = "";
    AppointmentRequest: string = "";
    LabRequest: string = "";
    RadiologyRequest: string = "";

    ngOnInit() {
        const ROUTE_DATA_BREADCRUMB: string = "breadcrumb";
        this.Hospital = localStorage.getItem("HospitalName");
        ////subscribe to the NavigationEnd event
        //this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {
        //    //set breadcrumbs
        //    let root: ActivatedRoute = this.activatedRoute.root;
        //    //this.currentPage = root.url.toString();
        //    this.breadcrumbs = this.getBreadcrumbs(root);
        //    if (this.breadcrumbs && this.breadcrumbs.length>0){
        //        this.currentPage = this.breadcrumbs[0].label;
        //    }
        //});
    }

    private getBreadcrumbs(route: ActivatedRoute, url: string = "", breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {
        const ROUTE_DATA_BREADCRUMB: string = "breadcrumb";

        //get the child routes
        let children: ActivatedRoute[] = route.children;
        this.currentPage = route.url.toString();

        //return if there are no more children
        if (children.length === 0) {
            return breadcrumbs;
        }

        //iterate over each children
        for (let child of children) {
            //verify primary route
            if (child.outlet !== PRIMARY_OUTLET) {
                continue;
            }

            //verify the custom data property "breadcrumb" is specified on the route
            if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
                return this.getBreadcrumbs(child, url, breadcrumbs);
            }

            //get the route's URL segment
            let routeURL: string = child.snapshot.url.map(segment => segment.path).join("/");

            //append route URL to URL
            url += `/${routeURL}`;

            //add breadcrumb
            let breadcrumb: IBreadcrumb = {
                label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
                params: child.snapshot.params,
                url: url
            };
            breadcrumbs.push(breadcrumb);
            this.AppointmentRequest = localStorage.getItem("StoreAppointmentRequest");
            this.LabRequest = localStorage.getItem("StoreLabRequest");
            this.RadiologyRequest = localStorage.getItem("StoreRadiologyRequest");
            //recursive
            return this.getBreadcrumbs(child, url, breadcrumbs);
        }
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/shared/breadcrumb/breadcrumb.component.ts